import React, { useState } from "react";
import styles from "./users.module.css";
import { RxCross1 } from "react-icons/rx";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import OrderDetails from "./OrderDetails";
import OrderInvoice from "./OrderInvoice";
import OrderStatus from "./OrderStatus";
import OrderChat from "./OrderChat";
import { useSelector } from "react-redux";

const OrderModal = ({ handleCloseOrderModal,OrderDataFun, isOrderDetail, orderData }) => {
  const [toggleContent, setToggleContent] = useState("Details");
  const [isFullWidth, setIsFullWidth] = useState(false);

  // console.log("orderData", orderData);

  const { theme } = useSelector((state) => state.theme);
  if (isOrderDetail) {
    return (
      <>
        <div className={styles.main}>
          <div
          style={isFullWidth?{width:'100%'}:{width:'550px'}}
            className={`${styles.container} ${
              theme === "light"
                ? "bg-secondaryColor text-textColorLight"
                : "bg-darkThirsary text-darkSecondary"
            } `}
          >
            <div className={`${styles.header_div} `}>
            <span
          onClick={() => setIsFullWidth((p) => !p)}
          className="cursor-pointer"
        >
          {isFullWidth ? <FaArrowRight /> : <FaArrowLeft />}
        </span>
              <span style={{ fontSize: "1.4rem" }}>Order Details</span>
              <RxCross1
                size={"1rem"}
                onClick={() => handleCloseOrderModal()}
                cursor={"pointer"}
              />
            </div>
            {/* <hr /> */}
            <div style={{ display: "flex" }}>
              {/* {["Details", "Invoice", "Status", "Chat"].map((item) => ( */}
              {["Details", "Invoice", "Status"].map((item) => (
                <hr
                  style={{
                    // width: "25%",
                    width: "33.3333333%",
                    borderTop:
                      item === toggleContent ? "5px solid  " : "1px solid",
                    color:
                      item === toggleContent
                        ? "rgb(15 61 100 / var(--tw-text-opacity)"
                        : "var(--light-color3)",
                    borderRadius: "10px",
                    borderBottom: "none",
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                />
              ))}
            </div>

            <div className={`${styles.content_list}  border-black-700 `}>
              {/* {["Details", "Invoice", "Status", "Chat"].map((item) => ( */}
              {["Details", "Invoice", "Status"].map((item) => (
                <span
                  onClick={() => setToggleContent(item)}
                  style={{
                    color:
                      item === toggleContent
                        ? "var(--color--2) "
                        : "var(--light-color3)",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
            </div>
            <hr />
            {toggleContent === "Details" && (
              <OrderDetails
                deliveryAddress={orderData?.delivery_address}
                handleCloseOrderModal={handleCloseOrderModal}
                orderDetails={orderData?.orderDetails}
                orderData={orderData}
                OrderDataFun={OrderDataFun}
              />
            )}
            {toggleContent === "Invoice" && (
              <OrderInvoice invoiceData={orderData} />
            )}
            {toggleContent === "Status" && (
              <OrderStatus orderStatus={orderData?.orderStatus} />
            )}
            {/* {toggleContent === "Chat" && <OrderChat />} */}
          </div>
        </div>
      </>
    );
  }
};

export default OrderModal;
